import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 添加编辑退税登记
 */
export const fetchAddEditDrawback = async (data) => {
    const res = await POST(APIs.API_SERVICE_ADDEDITTAXREBATES, { data });

    return res.data.data ?? {};
};

/**
 * 退税登记详情
 */
export const fetchDrawbackInfo = async (service_id) => {
    const res = await GET(APIs.API_SERVICE_TAXREBATESINFO, { params: { service_id } });

    return res.data.data ?? {};
};